import { LocalizationItem } from './LocalizationItem';

type LocalizationFallbackItems = {
  [index in LocalizationItem]: string;
};

export const localizationFallbackItems: LocalizationFallbackItems = {
  [LocalizationItem.Category]: 'Category',
  [LocalizationItem.Home]: 'Home',
  [LocalizationItem.Hide]: 'Hide',
  [LocalizationItem.HiHowCanWeHelp]: 'Hi, how can we help?',
  [LocalizationItem.MostCommonQuestions]: 'Most common questions',
  [LocalizationItem.NResultsForQuery]: "{count} results for ''{query}''",
  [LocalizationItem.Search]: 'Search',
  [LocalizationItem.ShowMore]: 'Show More',
  [LocalizationItem.SearchInSupportCenter]: 'Search in support center',
  [LocalizationItem.SupportCenter]: 'SupportCenter',
};
